import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class NavigationService {
    private history: string[] = [];
    private additionalParams:any[]=[];

    constructor(private router: Router) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                const urlBeforeRedirects = event.url;
                // if (this.history[this.history.length - 1] !== urlBeforeRedirects) {
                    this.history.push(urlBeforeRedirects);
                // }
            }
        });
    }

    pushToHistory(url: string): void {
        if (this.history[this.history.length - 1] !== url) {
            this.history.push(url);
            // this.additionalParams.push(additionalParam)
        }
    }

    getPreviousUrl(): string | any {
        console.log('this.hist', this.history)
        if (this.history.length >= 1) {
            if(this.additionalParams.length>0){
                return this.history.pop();
            }
            return this.history.pop();

        }
        return undefined;
    }

    getCurrentUrl(): string | undefined {
        return this.history[this.history.length - 1];
    }

    getHistory(): string[] {
        return [...this.history];
    }

    clearHistory(): void {
        this.history = [];
    }
}
